import { TextField, TextFieldProps } from "@mui/material";
import React from "react";

const InputField: React.FC<TextFieldProps> = (props) => {
  return <TextField {...props}>{props.children}</TextField>;
};

export default InputField;
